const PRODUCT_PERSONALISATION_SELECTOR = 'product-personalisation'
const PRODUCT_PERSONALISATION_TRIGGER_SELECTOR =
  '[data-product-personalisation-external-el="trigger"]'

const loader = document.getElementById('product-personalisation-loader')
const productPersonalisationSrc = loader?.dataset.src

let productPersonalisationPromise = null

function getPersonalisationTrigger (event) {
  if (!(event.target instanceof Element)) return null

  return event.target.closest(PRODUCT_PERSONALISATION_TRIGGER_SELECTOR)
}

function loadProductPersonalisation () {
  if (customElements.get(PRODUCT_PERSONALISATION_SELECTOR)) {
    return Promise.resolve()
  }

  if (productPersonalisationPromise) {
    return productPersonalisationPromise
  }

  if (!productPersonalisationSrc) {
    return Promise.reject(
      new Error('Missing product personalisation script source'),
    )
  }

  productPersonalisationPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.type = 'module'
    script.src = productPersonalisationSrc

    script.addEventListener('load', resolve)

    script.addEventListener('error', () => {
      reject(new Error('Failed to load product personalisation'))
    })

    document.head.appendChild(script)
  })
    .then(() => {
      document.removeEventListener('click', handlePersonalisationTrigger)
    })
    .catch((error) => {
      productPersonalisationPromise = null

      throw error
    })

  return productPersonalisationPromise
}

async function handlePersonalisationTrigger (event) {
  const trigger = getPersonalisationTrigger(event)

  if (!trigger) return
  if (customElements.get(PRODUCT_PERSONALISATION_SELECTOR)) return

  event.preventDefault()

  try {
    await loadProductPersonalisation()
    await customElements.whenDefined(PRODUCT_PERSONALISATION_SELECTOR)

    const personalisation = document.querySelector(
      PRODUCT_PERSONALISATION_SELECTOR,
    )

    if (!personalisation) {
      throw new Error('Product personalisation element was not found')
    }

    await personalisation.handleTrigger({
      target: trigger,
    })
  } catch (error) {
    console.error(
      '[ProductPersonalisationLoader] Failed to load personalisation',
      error,
    )
  }
}

document.addEventListener('click', handlePersonalisationTrigger)

if (
  new URLSearchParams(window.location.search).get('personalisation_debug') ===
  'true'
) {
  loadProductPersonalisation().catch((error) => {
    console.error(
      '[ProductPersonalisationLoader] Failed to load personalisation debugger',
      error,
    )
  })
}
